import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import { useStyles } from "../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import { url } from "../../../../Config/Config";
import Axios from "axios";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import StudentCard from "./StudentCard/StudentCard";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class StudentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentDetails: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getStudent(this.props.match.params.id);
    }
  }

  getStudent = async (studentId) => {
    try {
      const response = await Axios.get(`${url}/api/students/${studentId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.student.length !== 0) {
        this.setState({
          studentDetails: response.data.student,
          isEmpty: false,
        });
      } else {
        this.setState({
          studentDetails: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudent(studentId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { studentDetails } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Student Details"
            editUrl={`/administration/students/edit/${this.props.match.params.id}`}
            urlTitle="Edit Student"
          />

          {studentDetails.length !== 0 ? (
            <Grid container spacing={3}>
              <StudentCard student={studentDetails} />
            </Grid>
          ) : (
            this.state.isEmpty === false && <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(StudentDetail));
